export default __webpack_public_path__ + "8a222213cdc0a75a0714639b2d6ac02a.wav";